import React from "react";
import { Container } from "react-bootstrap";
import "./Home.css";
const Home = () => {
  return (
    <div className="homee">
      <Container>
        <h1 style={{ textAlign: "center", color: "black" }}>
          Welcome in our store
        </h1>
      </Container>
    </div>
  );
};

export default Home;
